/** specId -> the view ids that specification is included in. */
export type SpecificationMembership = Record<number, number[]>;

type SuiteWithSpecifications = { id: number; specifications: { id: number }[] };

/**
 * Restricts each suite's specifications to the ones included in that suite's
 * selected Test Suite View (ADR-0008). A missing/null entry in
 * `testSuiteViewId` means "All Tests" — no filtering for that suite. If the
 * membership matrix for a suite hasn't loaded yet, that suite is left
 * unfiltered rather than momentarily showing zero specifications.
 */
export function filterTestSuitesByView<T extends SuiteWithSpecifications>(
  testSuites: T[],
  testSuiteViewId: Record<number, number | null> | undefined,
  membershipBySuiteId: Record<number, SpecificationMembership | undefined>
): T[] {
  if (!testSuiteViewId) {
    return testSuites;
  }

  return testSuites.map((suite) => {
    const viewId = testSuiteViewId[suite.id];
    if (viewId == null) {
      return suite;
    }

    const membership = membershipBySuiteId[suite.id];
    if (!membership) {
      return suite;
    }

    return {
      ...suite,
      specifications: suite.specifications.filter((spec) => membership[spec.id]?.includes(viewId)),
    };
  });
}
